const initialState = {
  newContactForm: false,
  cntId: '',
  cntKey: null,
  cntDept: '',
  authLock: false,
  honorific: null,
  phone: null,
  fax: null,
  cntOrgId: '',
  placementCoordinator: false,
  caseManager: false,
  paroleAgent: false,
  supervisorChkBox: false,
  dataEntry: false,
  cntInactiveYn: false,
  networkUserName: null,
  county: null,
  cntSprCntId: '',
  cntEditCntId: '',
  cntName: null,
  firstName: '',
  middleName: '',
  lastName: '',
  suffix: null,
  title: null,
  directPhone: null,
  cntMailAdrPrefix: null,
  cntMailAdr: null,
  address1: null,
  address2: null,
  city: null,
  state: null,
  zip: null,
  email: null,
  createdDate: '',
  editDate: '',
  comment: null,
  cntCreateCntId: '',
  probationOfficer: false,
  organization: null,
  contactCreatedby: '',
  contactEditedby: '',
};
export default initialState;
